/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumEdit.vue?vue&type=template&id=009ef173&scoped=true"
import script from "./ForumEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumEdit.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumEdit.vue?vue&type=style&index=0&id=009ef173&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ef173",
  null
  
)

export default component.exports